// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2ZNe-","list":"PatternAutocomplete_list__1CDWj"};